const isNextChargeAvailable = (billingCycles: number | null = null, isTrial: boolean) => {
    return billingCycles !== 1 || (billingCycles === 1 && isTrial);
};

export default isNextChargeAvailable;
